export const GET_ACTIVE_HOMEPAGES = "GET_ACTIVE_HOMEPAGES";
export const GET_ACTIVE_HOMEPAGES_SUCCESS = "GET_ACTIVE_HOMEPAGES_SUCCESS";
export const GET_ACTIVE_HOMEPAGES_ERROR = "GET_ACTIVE_HOMEPAGES_ERROR";

export const GET_PREVIEW_HOMEPAGE = "GET_PREVIEW_HOMEPAGE";
export const GET_PREVIEW_HOMEPAGE_SUCCESS = "GET_PREVIEW_HOMEPAGE_SUCCESS";
export const GET_PREVIEW_HOMEPAGE_ERROR = "GET_PREVIEW_HOMEPAGE_ERROR";
